import { usePersistStore } from "../store";
import { useFollowSeller, useUnfollowSeller } from "../hooks/queries";

interface Props {
  sellerId?: string;
}

// Toggle button shown on the seller profile. Reads membership from the
// persist-store `following` array (hydrated at login) so the correct
// label renders immediately on page load without a round-trip. Hidden
// entirely on the signed-in user's own profile and when unauthenticated.
const FollowButton: React.FC<Props> = ({ sellerId }) => {
  const { token, user, following } = usePersistStore((s: any) => s);
  // Hooks must run unconditionally — declare before the early returns below.
  const follow = useFollowSeller();
  const unfollow = useUnfollowSeller();

  if (!sellerId) return null;
  if (!token) return null;
  if (user?._id && String(user._id) === String(sellerId)) return null;

  const isFollowing = (following || []).some(
    (id: string) => String(id) === String(sellerId)
  );
  const isBusy = follow.isPending || unfollow.isPending;

  const onClick = () => {
    if (isBusy) return;
    if (isFollowing) unfollow.mutate(sellerId);
    else follow.mutate(sellerId);
  };

  return (
    <button
      type="button"
      className={`followButton ${
        isFollowing ? "followButton--following" : "followButton--follow"
      }`}
      onClick={onClick}
      disabled={isBusy}
    >
      <i
        className={`bi ${isFollowing ? "bi-check2" : "bi-person-plus"}`}
        aria-hidden="true"
      />
      <span>{isFollowing ? "Following" : "Follow"}</span>
    </button>
  );
};

export default FollowButton;
